import { FC } from "react";

import { Center, Box } from "@chakra-ui/react";

import PDFViewer from "shared/PDFViewer/PDFViewer";
import { configs } from "shared/content/Content";
import { ResumePageId } from "utils/useScroll";
import { PageHeader } from "shared/page-header/PageHeader";


export const Resume: FC = () => {

  

    return (
         <Box id={ResumePageId}>
                     <PageHeader label="Resume" />
                     <Box mx="auto" p={6}>
            <Center   w="full">
                <PDFViewer pdfDocument={configs.common.resume}/>
            </Center>
        </Box>
        </Box>
    ); 
}
export default Resume;